module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/386.a43553c8.png";